import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../../../../common/components/icon/icon.component';
import { InsuranceQuestionDto } from '../../../../../../../core/data/dtos/insurance-question.dto';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-questions-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AppIconComponent, NgbTooltipModule],
  templateUrl: './questions-form.component.html',
})
export class QuestionsFormComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() categoryQuestions: InsuranceQuestionDto[] = [];

  questionKey(q: InsuranceQuestionDto): string {
    return `question_${q.id}`;
  }
}
